export const apiDriverRoutes = {
  routeDrivers: 'driver/driver',
};
